<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Procedimentos Cirúrgicos"
    >
        <Form
            :infraestruturaSolicitanteId="this.infraestruturaSolicitanteId"
            :procedimentosModal="this.procedimentosModal"
            :reguladorId="this.reguladorId"
            :sexoPaciente="this.sexoPaciente"
            ref="Form"
        />
        <List
            :isEdicao="this.isEdicao"
            :procedimentosModal="this.procedimentosModal"
            ref="List"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="handleSave"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

// Vuex
import { mapActions, mapGetters } from 'vuex'

// Mixins
import { object } from '@/mixins'

// Components
import Form from './Form'
import List from './List'

export default {

    components: { Form, List },
    computed: {

        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        procedimentosModal: [],
    }),
    methods: {

        ...mapActions(['someAction']),
        open() {

            this.procedimentosModal = this.clone(this.procedimentos);
            this.$refs.Modal.show();

        },
        handleSave() {

            this.$emit('addProcedimento', this.procedimentosModal);
            this.$refs.Modal.hide();
        },
    },
    mixins: [ object ],
    props: {
        infraestruturaSolicitanteId: { type: [String, Number], required: true, },
        isEdicao: { type: Boolean, default: false, },
        procedimentos: { type: Array, default: () => [], },
        reguladorId: { type: [String, Number], required: true, },
        sexoPaciente: { type:  [String, Number], required: true, },
    },
}
</script>